<span [ngClass]="{'p-calendar':true,'p-calendar-w-btn':showIcon}" [ngStyle]="style" [class]="styleClass">
            <ng-template [ngIf]="!inline">
                <input #inputfield type="text" spellcheck="false" [attr.id]="inputId" [attr.required]="required" [value]="inputFieldValue" (focus)="onInputFocus($event)" (keydown)="onInputKeydown($event)" (click)="closeOverlay=false" (blur)="onInputBlur($event)"
                    [readonly]="readonlyInput" (input)="onUserInput($event)" [ngStyle]="inputStyle" [class]="inputStyleClass" [placeholder]="placeholder||''" [disabled]="disabled" [attr.tabindex]="tabindex"
                    [ngClass]="'p-inputtext p-widget p-state-default p-corner-all'">
                    <button pButton type="button" *ngIf="showIcon" (click)="onButtonClick($event,inputfield)"
                    [ngClass]="{'p-datepicker-trigger':true,'p-state-disabled':disabled}" [disabled]="disabled" tabindex="-1"></button>
            </ng-template>
            <div #datepicker class="p-datepicker p-widget p-widget-content p-helper-clearfix p-corner-all" [ngClass]="{'p-datepicker-inline':inline,'p-shadow':!inline,'p-state-disabled':disabled,'p-datepicker-timeonly':timeOnly}" 
                [ngStyle]="{'display': inline ? 'inline-block' : (overlayVisible ? 'block' : 'none')}" (click)="onDatePickerClick($event)" [@overlayState]="inline ? 'visible' : (overlayVisible ? 'visible' : 'hidden')">
                <div class="p-datepicker-header p-widget-header p-helper-clearfix p-corner-all" *ngIf="!timeOnly && (overlayVisible || inline)">
                    <a class="p-datepicker-prev p-corner-all" href="#" (click)="prevMonth($event)">
                        <span class="fa fa-angle-left"></span>
</a>
<a class="p-datepicker-next p-corner-all" href="#" (click)="nextMonth($event)">
    <span class="fa fa-angle-right"></span>
</a>
<div class="p-datepicker-title">
    <span class="p-datepicker-month" *ngIf="!monthNavigator">{{locale.monthNames[currentMonth]}}</span>
    <span class="p-datepicker-year" *ngIf="!yearNavigator">{{currentYear}}</span>
</div>
</div>
<table class="p-datepicker-calendar" *ngIf="!timeOnly && (overlayVisible || inline)">
    <thead>
        <tr>
            <th scope="col" *ngFor="let weekDay of weekDays;let begin = first; let end = last">
                <span>{{weekDay}}</span>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let week of dates">
            <td *ngFor="let date of week" [ngClass]="{'p-datepicker-other-month p-state-disabled':date.otherMonth,
                                                  'p-datepicker-current-day':isSelected(date),'p-datepicker-today':date.today}">
                <a class="p-state-default" href="#" *ngIf="date.otherMonth ? showOtherMonths : true" [ngClass]="{'p-state-active':isSelected(date), 'p-state-highlight':date.today, 'p-state-disabled':!date.selectable}"
                    (click)="onDateSelect($event,date)">{{date.day}}</a>
            </td>
        </tr>
    </tbody>
</table>
</div>
</span>